import React from 'react';
import PropTypes from 'prop-types';

export function Wrapper(props) {
  return <div className={props.className}>{props.children}</div>;
}

Wrapper.propTypes = {
  /**
   * classname for wrapper
   */
  className: PropTypes.string,
  /**
   *  content to be displayed inside design section content wrapper
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};
